import React, { useContext, useMemo, useState } from 'react'
import { PROVIDER_ROLE } from '@trustero/trustero-api-web/lib/provider/provider_pb'
import { SERVICE_ROLE } from '@trustero/trustero-api-web/lib/service/service_pb'

type ScopingContextType = {
  currentProviderRole: PROVIDER_ROLE
  setCurrentProviderRole: React.Dispatch<React.SetStateAction<PROVIDER_ROLE>>
  currentServiceRole: SERVICE_ROLE
  setCurrentServiceRole: React.Dispatch<React.SetStateAction<SERVICE_ROLE>>
}

const ScopingContext = React.createContext<ScopingContextType>({
  currentProviderRole: PROVIDER_ROLE.CLOUD_HOSTING, // default value
  setCurrentProviderRole: () => null,
  currentServiceRole: SERVICE_ROLE.OTHER, // default value
  setCurrentServiceRole: () => null,
})

export const useScopingContext = (): ScopingContextType =>
  useContext(ScopingContext)

export const ScopingContextProvider = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const [currentProviderRole, setCurrentProviderRole] = useState<PROVIDER_ROLE>(
    PROVIDER_ROLE.CLOUD_HOSTING,
  )
  const [currentServiceRole, setCurrentServiceRole] = useState<SERVICE_ROLE>(
    SERVICE_ROLE.OTHER,
  )

  const scopingData: ScopingContextType = useMemo(
    () => ({
      currentProviderRole,
      setCurrentProviderRole,
      currentServiceRole,
      setCurrentServiceRole,
    }),
    [
      currentProviderRole,
      setCurrentProviderRole,
      currentServiceRole,
      setCurrentServiceRole,
    ],
  )
  return (
    <ScopingContext.Provider value={scopingData}>
      {children}
    </ScopingContext.Provider>
  )
}
